// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__153qF","submitContainer":"styles_submitContainer__2XJbr"};